import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getDocumentWorkflowKycForms } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { InvestorKycFormRes } from '@dealstack/shared/lib/generated';

type Options = Omit<
	UseQueryOptions<
		ApiV1.Response<InvestorKycFormRes[]>,
		unknown,
		InvestorKycFormRes[],
		[string, string]
	>,
	'queryKey' | 'queryFn' | 'select'
>;

export const useGetInvestorKycForms = (
	kycWorkflowId: string,
	options?: Options
): UseQueryResult<InvestorKycFormRes[] | undefined, unknown> => {
	const { ...queryOptions } = options || {};

	return useQuery({
		queryKey: [API_PATHS.SHAREHOLDER_KYC_KYC_FORMS_DOCUMENTWORKFLOW_GET, kycWorkflowId],
		queryFn: () => getDocumentWorkflowKycForms(kycWorkflowId),
		select: (data: ApiV1.Response<InvestorKycFormRes[]>) => data.payload ?? [],
		...queryOptions,
	});
};
